import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ariaLabel", "disabled", "focused", "hovered", "id", "Icon", "keyboardFocused", "onBlur", "onClick", "onFocus", "onMouseDown", "onMouseOut", "onMouseOver", "onMouseUp", "onPress", "onPressIn", "onPressOut", "onTouchEnd", "onTouchStart", "pressed", "tabIndex", "testID", "UNSAFE_touchableProps", "UNSAFE_iconProps", "colorToken", "colorTokenArgs", "isBig", "isSmall"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import Touchable from '@bubble-ui/primitive-touchable';
import View from '@bubble-ui/primitive-view';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import { useInteractiveStateCase } from '@bubble-ui/hook-use-interactive-state';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
import { defaultDesignTokens } from './defaultDesignTokens';
export var OverridableTouchableIcon = _ref => {
  var {
      ariaLabel,
      disabled,
      focused,
      hovered,
      id,
      Icon,
      keyboardFocused,
      onBlur,
      onClick,
      onFocus,
      onMouseDown,
      onMouseOut,
      onMouseOver,
      onMouseUp,
      onPress,
      onPressIn,
      onPressOut,
      onTouchEnd,
      onTouchStart,
      pressed,
      tabIndex,
      testID,
      UNSAFE_touchableProps,
      UNSAFE_iconProps,
      //props only used by getDefaultStyleSheet
      colorToken,
      colorTokenArgs,
      isBig,
      isSmall

      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'TouchableIcon',
    props,
    useInstead: 'UNSAFE_touchableProps',
    removalDate: 'v7.0.0'
  });
  var designContext = useDesignContext(defaultDesignTokens);
  var [interactiveState, eventHandlers] = useInteractiveStateCase(_objectSpread(_objectSpread({}, props), {}, {
    disabled,
    focused,
    hovered,
    keyboardFocused,
    onFocus,
    onBlur,
    onMouseDown,
    onMouseOut,
    onMouseOver,
    onMouseUp,
    onPressIn,
    onPressOut,
    onTouchEnd,
    onTouchStart,
    pressed
  }));

  // if no Icon was provided, there's no reason to keep going
  if (!Icon) {
    return null;
  }

  // we use the getDefaultStyleSheet directly since this component
  // can't be themed or overriden with StylesheetOverridesProvider
  var styleSheet = getDefaultStyleSheet({
    colorToken,
    colorTokenArgs,
    designContext,
    disabled,
    isBig,
    isSmall,
    interactiveState
  });
  var {
    ids
  } = getIds({
    id
  });
  return /*#__PURE__*/React.createElement(Touchable, _extends({
    id: ids === null || ids === void 0 ? void 0 : ids.root,
    testID: testID
  }, UNSAFE_touchableProps, {
    ariaLabel: ariaLabel,
    style: styleSheet.containerStyle,
    title: ariaLabel,
    type: "button",
    accessibilityState: {
      disabled
    },
    disabled: disabled,
    onClick: onClick,
    onPress: onPress,
    tabIndex: tabIndex
  }, props, eventHandlers), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.overlay,
    style: styleSheet.overlayStyle
  }, interactiveState === 'keyboardFocused' && /*#__PURE__*/React.createElement(View, {
    style: styleSheet.focusedBorderStyle
  }), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.iconWrapper,
    style: styleSheet.iconWrapperStyle
  }, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(Icon, _extends({
    id: ids === null || ids === void 0 ? void 0 : ids.icon
  }, UNSAFE_iconProps, {
    colorToken: styleSheet.iconColorToken,
    colorTokenArgs: styleSheet.iconColorTokenArgs
  }))))));
};
OverridableTouchableIcon.displayName = 'TouchableIcon';

// we only use ComponentOverrides for backwards compatibility
var TouchableIcon = withProvisionalOverrideFromContext(OverridableTouchableIcon);
export default TouchableIcon;
//# sourceMappingURL=index.js.map